
const ENV = process.env.NODE_ENV
export default {
  DOMAIN: 'http://127.0.0.1:8080',
  baseURL: "https://backendtv15k.sdzkedu.com",
  imageURL: "https://backendtv15k.sdzkedu.com",
  // baseURL: "http://backendtv15k.sdzkedu.com",
  // imageURL: "http://backendtv15k.sdzkedu.com",
  // baseURL: "http://test.edujianshe.com",
  // imageURL: "http://test.edujianshe.com",
  util: {
    image: '/util/image.html' // 图片上传
  }
}



// WEBPACK FOOTER //
// ./src/api/api.url.js